export default async function fetcher<T = unknown>(url: string): Promise<T> {
  const r = await fetch(url);
  return r.json() as Promise<T>;
}
